<section class="hero-wrap hero-wrap-2" style="background-image: url('../../assets/images/bg_4.jpg');">
    <div class="overlay"></div>
    <div class="container">
        <div class="row no-gutters align-items-center justify-content-center">

        </div>
    </div>
</section>

<div class="container">
    <div class="row">
        <div class="col-12" style=" margin-top: 50px;">
            <swiper [slidesPerView]="4" [pagination]="{ clickable: true }" [config]="swiperOp" [spaceBetween]="50"
            (slideChange)="onSlideChange()">
            <ng-template swiperSlide><img src="assets/images/img-1.png">Slide 1</ng-template>
            <ng-template swiperSlide><img src="assets/images/img-10.png">Slide 2</ng-template>
            <ng-template swiperSlide><img src="assets/images/img-3.png">Slide 3</ng-template>
            <ng-template swiperSlide><img src="assets/images/img-4.png">Slide 4</ng-template>
            <ng-template swiperSlide><img src="assets/images/img-5.png">Slide 5</ng-template>
            <ng-template swiperSlide><img src="assets/images/img-6.png">Slide 6</ng-template>
            <ng-template swiperSlide><img src="assets/images/img-7.png">Slide 7</ng-template>
            <ng-template swiperSlide><img src="assets/images/img-8.png">Slide 8</ng-template>
        </swiper>
        </div>
    </div>

</div>